<template>
  <mt-popup
    v-model="visible"
    popup-transition="popup-fade"
    class="home_login_modal"
    :closeOnClickModal="false"
    :class="classStyles"
  >
    <div>
      <div v-if="title" class="home_login_modal_title">{{ title }}</div>
      <slot name="modal_body"></slot>
    </div>
    <div v-if="isCancelBtn" class="home_login_modal_cancel">
      <img
        src="../static/images/vip_discounts/home_close.png"
        alt=""
        @click="cancelModalClick"
        class="home_login_modal_cancel_icon"
      />
    </div>
  </mt-popup>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      require: true,
      default: false,
    },
    title: {
      type: String,
      require: false,
      default: "",
    },
    isCancelBtn: {
      type: Boolean,
      require: false,
      default: true,
    },
    classStyles: {
      type: String,
      require: false,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},

  methods: {
    /** 关闭登录窗口 */
    cancelModalClick() {
      this.$emit("onCancel");
    },
  },
};
</script>
<style scoped lang="less">
.home_login {
  &_modal {
    width: 60%;
    padding: 16px 24px;
    border-radius: 24px;
    min-height: 400px;
    &_title {
      width: 100%;
      font-size: 30px;
      color: #090606;
      text-align: center;
      font-weight: bold;
      padding-top: 40px;
    }
    &_input {
      border: 1px solid #eeeeee;
      border-radius: 24px;
      margin: 24px 0px;
      &_error {
        color: #cd0c09;
        font-size: 18px;
      }
    }
    &_extra {
      color: #cd0c09;
      cursor: pointer;
    }
    &_btn {
      width: 85%;
      margin: 0 auto;
      background-color: #cd0c09;
      border-radius: 40px;
      height: 45px;
      text-align: center;
      color: #fff;
      line-height: 45px;
      margin-top: 24px;
      margin-top: 40px;
    }
    &_cancel {
      width: 40px;
      position: absolute;
      bottom: -100px;
      right: calc(50% - 20px);
      &_icon{
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
